import FormPageTemplate from '../forms/FormPageTemplate'

const RoofLandingForm = () => {
    const landingData = {
        title: "Your Roof Should Be Tougher.",
        subtitle: "Professional roof installation, replacement, and repair with Miami-Dade NOA-approved, hurricane-proof materials. Precision, durability, and guaranteed workmanship backed by a 10-year warranty."
    }
    
    return (
        <FormPageTemplate
            title="GET YOUR REPLACEMENT ROOF QUOTE NOW!"
            subtitle={landingData.title}
            defaultFormType="construction_new_project"
            returnPath="/landing-roof"
            initialPreselect={{ type: '1', desc: 'Re-Roof' }}
            thankYouPath="/landing-roof-form/thank-you"
        />
    )
}

export default RoofLandingForm
